import { Module } from '@msdyn365-commerce-modules/utilities';
/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IAccountInvoiceTileViewProps } from './account-invoice-tile';

export default (props: IAccountInvoiceTileViewProps) => {
    const { AccountInvoiceTile, heading, description, links } = props;

    return (
        <Module {...AccountInvoiceTile}>
            {heading}
            {description}
            {links}
        </Module>
    );
};
